import { Grid, makeStyles, Paper } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { CardAfiliado } from './ResumenHCE/CardAfiliado';
import { RecordatorioGeneral } from './ResumenHCE/RecordatorioGeneral';
import { RecordatorioPropio } from './ResumenHCE/RecordatorioPropio';
import { CardEmpadronamiento } from './ResumenHCE/CardEmpadronamiento';
import { CardMedicacion } from './ResumenHCE/CardMedicacion';
import { CardDiagnosticosActivos } from './DiagnosticosHCE/CardDiagnosticosActivos';
import { CardSignosVitales } from './ResumenHCE/CardSignosVitales';

const useStyles = makeStyles((theme) => {
  return {
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    content: {
      flexGrow: 1,
      marginTop: 25,
    },
    fixedHeight: {
      height: 350,
    },
    icon: {
      marginRight: theme.spacing(2),
    },
    heroContent: {
      padding: theme.spacing(0, 0, 0),
      marginTop: '50px',
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    footer: {
      padding: theme.spacing(3),
      marginTop: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
  };
});

export const TabResumen = (props) => {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const { hce, dataAfiliado, problemas, estadosProblemas, disabled, autopercepcionAfi } = props;


  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3} lg={3}>
          <Paper className={fixedHeightPaper}>
            <CardAfiliado dataAfiliado={dataAfiliado} autopercepcionAfi={autopercepcionAfi} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Paper className={fixedHeightPaper} >
            <CardDiagnosticosActivos
              dataAfiliado={dataAfiliado}
              problemasAfiliiado={problemas}
              estadosProblemas={estadosProblemas}
              hce={hce}
              disabled={disabled}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <Paper className={fixedHeightPaper} >
            <RecordatorioGeneral dataAfiliado={dataAfiliado} hce={hce} disabled={disabled} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <Paper className={fixedHeightPaper} >
            <RecordatorioPropio dataAfiliado={dataAfiliado} hce={hce} disabled={disabled} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={8} lg={8}>
          <Paper className={fixedHeightPaper} >
            <CardSignosVitales hce={hce} dataAfiliado={dataAfiliado} disabled={disabled} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Paper className={fixedHeightPaper} >
            <CardEmpadronamiento hce={hce} dataAfiliado={dataAfiliado} disabled={disabled} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Paper className={fixedHeightPaper} >
            <CardMedicacion hce={hce} dataAfiliado={dataAfiliado} disabled={disabled} />
          </Paper>
        </Grid>
        {/* <Grid item xs={12} md={6} lg={6}>
          <Paper className={fixedHeightPaper} >
            <CardRecetasPaciente hce={hce} dataAfiliado={dataAfiliado} disabled={disabled}/>
          </Paper>
        </Grid> */}

      </Grid>
    </React.Fragment>
  );
};
